<template>
  <div
    class="truncate text-xs md:text-sm"
    :title="label"
  >
    <FaIcon
      name="users"
      variant="light"
      class="mr-1"
    />
    {{ label }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { Owner } from '@/api/contracts/types';
import FaIcon from '@/application/components/ui/FaIcon.vue';

interface Props {
  owner: Owner,
}

const props = defineProps<Props>();

const label = computed(() => `Mitversichert bei ${props.owner.firstName} ${props.owner.lastName}`);
</script>
